import { fastHashCode } from "fast-hash-code";
import { colord } from "./color";

/**
 * Converts a name to two uppercase initials.
 * @example
 * nameToInitials("John Doe"); // "JD"
 */
const nameToInitials = (name?: string) => {
  if (!name) return "U";

  const wordSplitterRegex = /[\s-']/g;
  const wordWithUnicodeCharsRegex = /[\w\p{L}]+/gu;
  const nameWords = name.split(wordSplitterRegex);
  const filteredNameWords = nameWords.filter(word =>
    word.match(wordWithUnicodeCharsRegex),
  );
  const firstInitial = filteredNameWords.shift()?.charAt(0) ?? "";
  const lastInitial = filteredNameWords.pop()?.charAt(0) ?? "";
  const initials = firstInitial + lastInitial;

  return initials.toUpperCase();
};

/**
 * Converts a name to a HSL color, making sure that a pure white text color
 * is readable on top of it.
 * @example
 * nameToHslColor("John Doe"); // "hsl(229, 84%, 60%)"
 */
const nameToHslColor = (name?: string) => {
  if (!name) {
    return "hsl(229, 84%, 60%)";
  }

  const numberHash = fastHashCode(name, { forcePositive: true });
  const validHueValue = numberHash % 360;
  let color = `hsl(${validHueValue}, 66%, 45%)`;

  while (!colord("#fff").isReadable(color)) {
    color = colord(color).darken(0.1).toHslString();
  }

  return color;
};

export { nameToInitials, nameToHslColor };
